<div class="width-lg max-width-xl">
  <div>
    <div class="code-container-width">
      <strong>{{ code }}</strong>
    </div>
    <small class="float-right"> {{ amount | currencyWithSpace: currency }} </small>
  </div>
  <div>
    <small>{{ company }}</small>
  </div>
  <div>
    <small>{{ date | customDate }}</small>
  </div>

  <nz-divider class="m-none"></nz-divider>
</div>